import { render, staticRenderFns } from "./BranchDialog.vue?vue&type=template&id=bb130496&"
import script from "./BranchDialog.vue?vue&type=script&lang=ts&"
export * from "./BranchDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports